// Add {hide: true} in object to hide any menu from menu bar
import { MainMenu } from "./constants";

export const menusArray: Array<MainMenu> = [
  {
    pageId: 1,
    name: "Create User",
    class: "innerDropdown",
    icon: "user",
    title: "Create User",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 2,
    name: "Update User",
    class: "innerDropdown",
    icon: "user secret",
    title: "Update User",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 3,
    name: "Usage Report",
    class: "innerDropdown",
    icon: "file",
    title: "Usage Report",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 4,
    name: "API Request Module",
    class: "innerDropdown",
    icon: "file",
    title: "API Request Module",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 5,
    name: "Update Bulk User",
    class: "innerDropdown",
    icon: "users",
    title: "Update Bulk User",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 6,
    name: "Update Bulk Providers",
    class: "innerDropdown",
    icon: "user doctor",
    title: "Update Bulk Providers",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 7,
    name: "OD Adjustments",
    class: "innerDropdown",
    icon: "list",
    title: "OD Adjustments",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 14,
    name: "OD Payment Types",
    class: "innerDropdown",
    icon: "credit card",
    title: "OD Payment Types",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 15,
    name: "Fee Schedules",
    class: "innerDropdown",
    icon: "dollar sign",
    title: "Fee Schedules",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 16,
    name: "Ins Plans UCR",
    class: "innerDropdown",
    icon: "shield",
    title: "Ins Plans UCR",
    partner: "",
    role: [],
    subMenus: [],
  },
  {
    pageId: 8,
    name: "Reset Password",
    class: "innerDropdown",
    icon: "lock",
    title: "Reset Password",
    partner: "",
    role: [],
    subMenus: [],
  },

];
